function TechStack(){

    return(<div className="">
        <div className="mx-auto max-w-7xl py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold tracking-tight text-black">
            Our tech stack
          </h2>
          <div className="mt-4 flow-root lg:mt-10">
            <div className="-mt-4 -ml-4 flex flex-wrap justify-between lg:ml-2">
              <div className="mt-4 ml-8 flex flex-shrink-0 flex-grow lg:ml-4 lg:flex-grow-0">
                <img className="h-12" src="https://cdn-icons-png.flaticon.com/256/1199/1199124.png" alt="Javascrtipt" />
              </div>
              <div className="mt-4 ml-8 flex flex-shrink-0 flex-grow lg:ml-4 lg:flex-grow-0">
                <img className="h-12" src="https://cdn-icons-png.flaticon.com/512/5968/5968350.png" alt="Python" />
              </div>
              <div className="mt-4 ml-8 flex flex-shrink-0 flex-grow lg:ml-4 lg:flex-grow-0">
                <img
                  className="h-12"
                  src="https://icon.icepanel.io/Technology/svg/React.svg"
                  alt="React"
                />
              </div>
              <div className="mt-4 ml-8 flex flex-shrink-0 flex-grow lg:ml-4 lg:flex-grow-0">
                <img
                  className="h-12"
                  src="https://static.djangoproject.com/img/logos/django-logo-negative.png"
                  alt="Django"
                />
              </div>
              <div className="mt-4 ml-8 flex flex-shrink-0 flex-grow lg:ml-4 lg:flex-grow-0">
                <img
                  className="h-12"
                  src="https://icon.icepanel.io/Technology/svg/Tailwind-CSS.svg"
                  alt="Taildwind"
                />
              </div>
            </div>
          </div>
        </div>
      </div>)



}

export default TechStack